import { ISource } from '../user/store';

export interface IAdminClubCardStore {
  [clubId: number]: ISource[];
}

export const adminClubCardStore: IAdminClubCardStore = [];
